import { render, staticRenderFns } from "./CommonMiniUpload.vue?vue&type=template&id=5588ba35&scoped=true"
import script from "./CommonMiniUpload.vue?vue&type=script&lang=js"
export * from "./CommonMiniUpload.vue?vue&type=script&lang=js"
import style0 from "./CommonMiniUpload.vue?vue&type=style&index=0&id=5588ba35&prod&lang=css"
import style1 from "./CommonMiniUpload.vue?vue&type=style&index=1&id=5588ba35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5588ba35",
  null
  
)

export default component.exports